import { Typo3SectionSpotSanityContentText } from '@/types/typo3'
import { Button, Title } from '@/ui/components'
import { memo } from 'react'

interface Props {
  data: Typo3SectionSpotSanityContentText['content']['contacts']
}

const Contacts = ({ data }: Props) => {
  if (!data?.length) {
    return null
  }

  return (
    <div
      className={'p-lg gap-lg flex flex-col bg-neutral-200 text-neutral-600'}
    >
      {data?.map((c) => (
        <div key={c?.uid} className={''}>
          <Title as="h4" className="textstyle-md-bold">
            {c?.title}
          </Title>
          <div>
            {c?.firstname && (
              <p>
                {c?.salutation && `${c?.salutation} `} {c?.firstname}{' '}
                {c?.lastname && `${c?.lastname} `}
              </p>
            )}
            <p>{c?.street}</p>
            <p>{`${c?.zipcode} ${c?.city}  `}</p>
          </div>{' '}
          <div className={'gap-2xs align-start mt-sm flex flex-col'}>
            {c?.website && (
              <div>
                <Button
                  icon="material-symbols:open-in-new-sharp"
                  size="s"
                  variant="text"
                  iconPosition="left"
                  href={`${c?.website}`}
                  target="_blank"
                  nextLink={false}
                >
                  Website
                </Button>
              </div>
            )}
            {c?.email && (
              <div>
                <Button
                  icon="material-symbols:mail-sharp"
                  size="s"
                  variant="text"
                  iconPosition="left"
                  href={`mailto:${c?.email}`}
                  target="_blank"
                  nextLink={false}
                >
                  {c?.email}
                </Button>
              </div>
            )}
            {c?.phone && (
              <div>
                <Button
                  icon="material-symbols:phone-enabled-sharp"
                  size="s"
                  variant="text"
                  iconPosition="left"
                  href={`tel:${c?.phone}`}
                  target="_blank"
                  nextLink={false}
                >
                  {c?.phone}
                </Button>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
export default memo(Contacts)
